import "./index.css";
import React from "react";
import EyeIcon from "../../screens/ProductPortfolio/components/EyeIcon";

export default function StatusButton({
  isPublic,
  onClick,
  className,
  isDisabled = false,
}) {
  return (
    <button
      type="button"
      disabled={isDisabled}
      className={`status-button ${isPublic ? "" : "status-button--gray-bg"} ${
        isDisabled ? "status-button--disabled" : ""
      } ${className}`}
      onClick={onClick}
    >
      {isPublic ? "Public " : "Private "}
      <EyeIcon isPublic={isPublic} fill={isPublic ? "#595959" : "#fff"} />
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/StatusButton/index.js